import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { request } from '../../axios';
import type { PatientDto } from '../model';

export interface SyncAddressVariables {
    patientId: string;
    referenceType: string;
}

export const syncAddress = (
    patientId: string,
    referenceType: string,
    signal?: AbortSignal,
) => {
    return request<PatientDto>({
        url: `/api/patients/${patientId}/sync-address`,
        method: 'POST',
        params: {
            referenceType,
        },
        signal,
    });
};

export const useSyncAddressMutation = (
    options?: UseMutationOptions<PatientDto, Error, SyncAddressVariables>,
) => {
    return useMutation<PatientDto, Error, SyncAddressVariables>({
        mutationFn: ({ patientId, referenceType }) => syncAddress(patientId, referenceType),
        ...options,
    });
};
